import {HighlightSlide} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/highlight.types';
import {
  TrackingPageTypeWithoutId,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {usePromotionTrackingCallback} from '@aboutyou/tracking';
// eslint-disable-next-line monorepo/no-internal-import

export const useHighlightZoomSliderTracking = () => {
  const track = usePromotionTrackingCallback();

  return ({
      streamPosition,
      slide: slideToTrack,
      highlightId,
    }: {
      streamPosition: number;
      slide: HighlightSlide;
      highlightId: number;
    }) =>
    (type: 'click' | 'impression') => {
      track({
        streamPosition,
        promotion: {
          source: TrackingPromotionCreative.Highlight,
          highlightId,
          path: slideToTrack.cta?.link.url,
          external: slideToTrack.cta?.link.external,
          promotionId: slideToTrack.tracker.promotionId,
          promotionName: slideToTrack.tracker.promotionName,
          trackHighlightIdAsPageId: true,
        },
        pageType: TrackingPageTypeWithoutId.highlightPage,
        recoList: {
          sectionIndex: 0,
          recoType: 'brands_highlight_slide',
          elements: [],
        },
      })(type);
    };
};
